// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "info-1aWQ3";
var _3 = "segments-yew25";
var _4 = "footer-3zhpx";
var _5 = "button_default-3-Ok1";
var _6 = "button-3oF0R";
export { _1 as "__esModule", _2 as "info", _3 as "segments", _4 as "footer", _5 as "button_default", _6 as "button" }
export default { "__esModule": _1, "info": _2, "segments": _3, "footer": _4, "button_default": _5, "button": _6 }
